import React from 'react';
export function EliteSection() {
  return <section className="w-full bg-[#1a1400] py-16 px-4" data-id="element-74">
      <div className="max-w-4xl mx-auto" data-id="element-75">
        <div className="text-center mb-10" data-id="element-76">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-4" data-id="element-77">
            🎹 ¿Qué agrega{' '}
            <span className="text-[#FFD700]" data-id="element-78">Academia Explosiva™</span>?
          </h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto" data-id="element-79">
            Vos ya tenés las clases resueltas (MegaPack). Academia Explosiva le
            da el sistema de negocio que hace que enseñar piano sea rentable,
            predecible y escalable.
          </p>
        </div>

        {/* Comparison Table */}
        <div className="bg-black border border-[#FFD700]/30 rounded-2xl overflow-hidden mb-12" data-id="element-80">
          <div className="grid grid-cols-1 sm:grid-cols-3 bg-[#0d0a00] border-b border-[#FFD700]/30" data-id="element-81">
            <div className="p-4 font-bold text-white hidden sm:block" data-id="element-82">
              Situación
            </div>
            <div className="p-4 font-bold text-gray-400 text-center border-l border-[#FFD700]/30" data-id="element-83">
              Sin Academia Explosiva
            </div>
            <div className="p-4 font-bold text-[#FFD700] text-center border-l border-[#FFD700]/30" data-id="element-84">
              Con Academia Explosiva
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-85">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-86">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-87">
                Situación:
              </span>
              Un alumno no paga el mes
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-88">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-89">
                Sin Academia Explosiva:
              </span>
              No tenés respaldo — lo perseguís incómodo
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#FFD700]/5" data-id="element-90">
              <span className="sm:hidden font-bold text-[#FFD700] block mb-1" data-id="element-91">
                Con Academia Explosiva:
              </span>
              Aplicás el contrato maestro que firmó. El cobro es un
              procedimiento, no una conversación difícil
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-92">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-93">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-94">
                Situación:
              </span>
              Querés subir el precio
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-95">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-96">
                Sin Academia Explosiva:
              </span>
              No sabés cuánto cobrar ni cómo comunicarlo
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#FFD700]/5" data-id="element-97">
              <span className="sm:hidden font-bold text-[#FFD700] block mb-1" data-id="element-98">
                Con Academia Explosiva:
              </span>
              Usás la calculadora de precios + el script de comunicación del
              aumento. Sin perder alumnos
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-99">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-100">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-101">
                Situación:
              </span>
              Necesitás más alumnos
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-102">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-103">
                Sin Academia Explosiva:
              </span>
              Esperás que alguien te recomiende
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#FFD700]/5" data-id="element-104">
              <span className="sm:hidden font-bold text-[#FFD700] block mb-1" data-id="element-105">
                Con Academia Explosiva:
              </span>
              Activás el sistema de referidos + Google Maps + Instagram para
              profesores. Nuevos alumnos en 30 días
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-106">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-107">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-108">
                Situación:
              </span>
              Un alumno falta seguido
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-109">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-110">
                Sin Academia Explosiva:
              </span>
              Lo llamás, le rogás, perdés dinero
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#FFD700]/5" data-id="element-111">
              <span className="sm:hidden font-bold text-[#FFD700] block mb-1" data-id="element-112">
                Con Academia Explosiva:
              </span>
              Activás el protocolo de retención VIP + los scripts de
              seguimiento. La falta te avisa antes de convertirse en abandono
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-113">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-114">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-115">
                Situación:
              </span>
              Querés crecer pero no tenés más horas
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-116">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-117">
                Sin Academia Explosiva:
              </span>
              No hay solución visible
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#FFD700]/5" data-id="element-118">
              <span className="sm:hidden font-bold text-[#FFD700] block mb-1" data-id="element-119">
                Con Academia Explosiva:
              </span>
              Implementás grupos + primer colaborador según el plan de 90 días
              del Módulo 5
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3" data-id="element-120">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-121">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-122">
                Situación:
              </span>
              Fin de año y no creciste
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-123">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-124">
                Sin Academia Explosiva:
              </span>
              Otro año igual
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#FFD700]/5" data-id="element-125">
              <span className="sm:hidden font-bold text-[#FFD700] block mb-1" data-id="element-126">
                Con Academia Explosiva:
              </span>
              Tenés el plan de 90 días con indicadores concretos de seguimiento
            </div>
          </div>
        </div>

        {/* Features List */}
        <h3 className="text-2xl font-black text-white text-center mb-8" data-id="element-127">
          ✅ ACADEMIA EXPLOSIVA™ INCLUYE:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-128">
          <div className="bg-black border border-[#FFD700]/20 rounded-xl p-5" data-id="element-129">
            <h4 className="text-[#FFD700] font-bold text-lg mb-2" data-id="element-130">
              ⚖️ Módulo 1 — Marco Legal y Contratos
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-131">
              Contrato maestro listo para usar (sin abogado). Política de
              cancelación clara. Formulario de inscripción y ficha del alumno.
              Autorización de imagen. Scripts para presentar el contrato sin
              perder alumnos. Guiones para las 5 situaciones legales más
              comunes.
            </p>
          </div>
          <div className="bg-black border border-[#FFD700]/20 rounded-xl p-5" data-id="element-132">
            <h4 className="text-[#FFD700] font-bold text-lg mb-2" data-id="element-133">
              💰 Módulo 2 — Finanzas y Sistema de Cobros
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-134">
              Calculadora de precios profesional. Sistema de mes adelantado paso
              a paso. Configuración de Mercado Pago y suscripciones automáticas.
              Planilla de ingresos mensual. Scripts de recordatorio de pago.
              Comunicación de aumento de precio lista.
            </p>
          </div>
          <div className="bg-black border border-[#FFD700]/20 rounded-xl p-5" data-id="element-135">
            <h4 className="text-[#FFD700] font-bold text-lg mb-2" data-id="element-136">
              🧲 Módulo 3 — Marketing y Captación de Alumnos
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-137">
              Perfil de Google Maps optimizado (aparecer primero sin pagar
              anuncios). Sistema de Instagram para profesores: 30 ideas de
              contenido listas. Sistema de referidos que llena tu agenda solo.
              Scripts para pedir reseñas. Primera clase gratuita: la mejor
              herramienta de venta.
            </p>
          </div>
          <div className="bg-black border border-[#FFD700]/20 rounded-xl p-5" data-id="element-138">
            <h4 className="text-[#FFD700] font-bold text-lg mb-2" data-id="element-139">
              🔥 Módulo 4 — Comunicación y Retención
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-140">
              Sistema VIP WhatsApp con calendario semanal de comunicaciones.
              Banco de tips musicales para 12 semanas. Cómo organizar recitales
              hogareños que retienen alumnos. Programa de concierto imprimible.
              Los momentos de orgullo que hacen que nadie se vaya.
            </p>
          </div>
          <div className="bg-black border border-[#FFD700]/20 rounded-xl p-5 md:col-span-2" data-id="element-141">
            <h4 className="text-[#FFD700] font-bold text-lg mb-2" data-id="element-142">
              📈 Módulo 5 — Escalabilidad
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-143">
              Las 4 estrategias para crecer sin trabajar más horas. Cuándo y
              cómo conseguir tu primer colaborador. Clases online: herramientas
              y configuración. Análisis de costos: home studio vs local. Plan de
              90 días para duplicar ingresos con indicadores de seguimiento.
            </p>
          </div>
        </div>
      </div>
    </section>;
}